import type { AxiosResponse } from 'axios';
import api from 'src/services/api';
import * as utils from './apiUtils';
import type { EmergencyIndexParams } from 'src/models/apis/extLandApEmergency/extLandApEmergencyRequest';
import {
  type EmergencyIndexResponse,
  toEmergency,
} from 'src/models/apis/extLandApEmergency/extLandApEmergencyResponse';
import type { Emergency } from 'src/models/extLandApEmergency';

export default {
  async index(params: EmergencyIndexParams): Promise<Emergency[]> {
    const response = await api.get<EmergencyIndexResponse>(utils.getApiUrl('/ext/land-ap/emergency'), { params });
    return response.data.map(toEmergency);
  },
  getImage(id: number): Promise<AxiosResponse<Blob>> {
    return api.get(utils.getApiUrl(`/ext/land-ap/image/${id}`), {
      responseType: 'blob',
    });
  },
};
